import { forwardRef } from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';

const Toaster = forwardRef(
  ({ children, isOpen, className }, ref) =>
    isOpen &&
    createPortal(
      <div ref={ref} className={classNames('toaster-wrapper', className)}>
        {children}
      </div>,
      document.getElementById('toasters'),
    ),
);

export default Toaster;
